import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sgNegate',
  standalone: false,
})
export class SgNegatePipe implements PipeTransform {
  transform(value: any): boolean {
    return !value;
  }
}
